// Vite entrypoint for brand pages AND static pages (about, pricing, features,
// faq, contact, support, privacy, terms, cookies, changelog, status,
// methodology, glossary, security, gdpr, dpa).
// initBrands() uses path-based routing and gracefully no-ops for non-brand pages.
import '../js/shared/fonts.ts'
import { enforcePreferredLocale } from '../js/shared/auth-locale-redirect.ts'
enforcePreferredLocale()
import { initAppsignal } from '../js/shared/appsignal.ts'
initAppsignal()
import '../css/style.css'
import '../js/components'
// Turbo only drives <turbo-frame>s (Drive is off), and of the pages this
// entrypoint serves only /pricing renders one. A static import cost every
// brand, product, legal and info page 89 kB (25 kB gzipped) of script.
if (document.querySelector('turbo-frame')) void import('../js/shared/turbo.ts')
import '../css/brands.css'
import '../css/brands-blueprint.css'
import '../css/features-blueprint.css'
import '../css/pricing-blueprint.css'
import '../css/info-pages-blueprint.css'
import { initBrands } from '../js/pages/brands'
import { initFeedback } from '../js/pages/feedback.ts'
import { initNozzleCalculator } from '../js/pages/nozzle-calculator.ts'
import { initFaqPage } from '../js/pages/faq.ts'
import { initSearch } from '../js/shared/search.ts'
import { bindCopyButtons } from '../js/shared/clipboard.ts'

document.addEventListener('DOMContentLoaded', async () => {
  // initI18n is called inside initBrands() — no need to call it twice
  await initBrands()
  initSearch()
  initFeedback()
  initNozzleCalculator()
  initFaqPage()
  // Generic copy-to-clipboard wiring for `<button data-copy-text="...">` —
  // currently used by the /contact email directory cards.
  bindCopyButtons()
})
